// extracted by mini-css-extract-plugin
export default {"tooltip":"MQ-z","arrow":"NQ-z"};